import styles from './liquidity-withdraw-dialog.module.css';
import {Button, Dialog, Divider, IconButton} from '@mui/material';
import closeImage from '../../images/close.svg';
import React, {useContext} from 'react';
import {useWeb3React} from '@web3-react/core';
import {parseEther} from '@ethersproject/units';
import {LoadingContext, LoadingItem} from '../../context/loader';
import {LiquidityMiningService} from "../../services/LiquidyMiningService";
import bigInt, {BigInteger} from "big-integer";
import {MessageContext} from "../../context/messaging";

function LiquidityWithdrawDialog(props: {
    open: boolean;
    handleWithdrawDialogClose: any;
    handleWithdrawDialogOpen: any;
    data: any;
}) {

    const [withdrawAmount, setWithdrawAmount] = React.useState('');
    const {library} = useWeb3React();
    const {
        setRefresh, setLoadingData, loadingData
    } = useContext(LoadingContext);

    const {
        setMessageOpen,
        setSeverity,
        setMessageText
    } = useContext(MessageContext);

    function handleWithdrawAmountChange(evt: React.ChangeEvent<HTMLInputElement>) {
        const financialGoal = (evt.target.validity.valid) ? evt.target.value : withdrawAmount;
        setWithdrawAmount(financialGoal);
    }

    function unStakeEnable() {

        let amount: BigInteger = bigInt(0);
        try {
            amount = bigInt(parseEther(withdrawAmount).toString());
        } catch (e) {
            return false;
        } finally {
        }
        return (
            props.data !== undefined &&
            props.data.balance !== undefined &&
            withdrawAmount.charAt(withdrawAmount.length - 1) !== '.' &&
            bigInt(parseEther(withdrawAmount).toString()).compare(
                bigInt(parseEther(props.data.stakedBalance.toString()).toString())) <= 0 &&
            amount.compare(bigInt(0)) === 1
        );
    }


    const unStake = async () => {
        loadingData.set('LiquidityMining-UnStake', {message: 'Unstaking...'});
        setLoadingData(new Map<string, LoadingItem>(loadingData));
        let hasError = false;

        let tx = await LiquidityMiningService(library, props.data.stakingType).withdraw(parseEther(withdrawAmount).toString()).catch((error) => {
            console.log(error);
            setMessageOpen(true);
            setSeverity("error");
            setMessageText('UnStaking failed.');
            hasError = true;
        });
        if (tx !== undefined) {
            await tx.wait().catch((error: any) => {
                console.log(error);
                setMessageOpen(true);
                setSeverity("error");
                setMessageText('UnStaking failed.');
                hasError = true;
            });
        }
        loadingData.delete('LiquidityMining-UnStake');
        setLoadingData(new Map<string, LoadingItem>(loadingData));
        if (!hasError) {
            setMessageOpen(true);
            setSeverity("success");
            setMessageText('UnStaking successfully done.');
        }
        setRefresh('LiquidityMining_' + props.data.stakingType + "_" + new Date().getTime());
        setWithdrawAmount('');
        props.handleWithdrawDialogClose();
    };

    return (
        <div className={`${styles.container}`}>
            <Dialog open={props.open} onClose={props.handleWithdrawDialogClose}>
                <div>
                    <div className={`${styles.header}`}>
                        <div className={`${styles.headerText}`}>Liquidity UnStaking</div>
                        <div className={`${styles.closeImage}`}>
                            <IconButton
                                aria-label="Close"
                                onClick={() => {
                                    setWithdrawAmount('');
                                    props.handleWithdrawDialogClose();
                                }}
                            >
                                <img alt="" src={closeImage}/>
                            </IconButton>
                        </div>
                    </div>
                    <div className={`${styles.divider}`}>
                        <Divider/>
                    </div>
                    <div className={`${styles.balanceText}`}>
                        Your stake: {props.data ? (props.data.stakedBalance.toString()) : 0}
                    </div>
                    <div className={`${styles.amountContainer}`}>
                        <div  className={`${styles.amountDiv}`}>
                            <div className={`${styles.amountLabel}`}>Amount</div>
                            <div className={`${styles.textContainer}`}>
                                <input
                                    pattern="[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)"
                                    id="txtWithdrawAmount"
                                    type="text"
                                    value={withdrawAmount}
                                    className={`${styles.text}`}
                                    onChange={handleWithdrawAmountChange}
                                />
                            </div>
                        </div>
                        <div className={`${styles.maxButtonPanel}`}>
                            <Button
                                className={`${styles.maxButton}`}
                                style={{textTransform: 'unset'}}
                                onClick={() => {
                                    if (props.data !== null && props.data.stakedBalance != null) {
                                        setWithdrawAmount(props.data.stakedBalance.toString());
                                    } else {
                                        setWithdrawAmount('');
                                    }
                                }}
                            >
                                Max
                            </Button>
                        </div>
                    </div>
                    <div className={`${styles.divider}`}>
                        <Divider/>
                    </div>
                    <div className={`${styles.actionPanel}`}>
                        <div
                            className={
                                unStakeEnable()
                                    ? `${styles.approveButtonEnable}`
                                    : `${styles.approveButtonDisable}`
                            }
                        >
                            <Button
                                className={`${styles.approveButtonText}`}
                                style={{textTransform: 'unset'}}
                                onClick={unStake}
                                disabled={!unStakeEnable()}
                            >
                                Unstake
                            </Button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default LiquidityWithdrawDialog;
